<template>
  <div class="table-container">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 1rem; margin-bottom: 1rem">
      <div style="display: flex; align-items: end; justify-content: end; gap: 1rem">
        <!-- vs-select for filtering reviews based on stars -->
        <vs-select label="Fiter by rating" v-model="filters.showStars" placeholder="Filter by Stars" @change="fetchReviews">
          <vs-select-item value="all" text="All"></vs-select-item>
          <vs-select-item value="1" text="1 star"></vs-select-item>
          <vs-select-item value="2" text="2 stars"></vs-select-item>
          <vs-select-item value="3" text="3 stars"></vs-select-item>
          <vs-select-item value="4" text="4 stars"></vs-select-item>
          <!-- <vs-select-item value="5" text="5 stars"></vs-select-item> -->
        </vs-select>

        <!-- vs-select for filtering reviews based on resolved status -->
        <vs-select label="Fiter by resolved" v-model="filters.showResolved" placeholder="Filter by Resolved" @change="fetchReviews">
          <vs-select-item value="all" text="Both"></vs-select-item>
          <vs-select-item value="yes" text="Resolved"></vs-select-item>
          <vs-select-item value="no" text="Unresolved"></vs-select-item>
        </vs-select>
        <!-- vs-select for filtering reviews based on page limit -->
        <vs-select label="Page Limit" v-model="limit" @change="searchData()">
          <vs-select-item value="15" text="15" />
          <vs-select-item value="30" text="30" />
          <vs-select-item value="50" text="50" />
        </vs-select>
        <vs-button
          @click="
            filters.showStars = 'all';
            filters.showResolved = 'all';
            fetchReviews();
          "
          class="mt-2"
          icon="refresh"
          style="border-radius: 50%"
        ></vs-button>
      </div>
    </div>
    <table class="review-table" v-if="reviews.length > 0">
      <thead>
        <tr>
          <th @click="sortBy('position')" style="cursor: pointer; text-align: center">
            Date
            <span v-if="sortByField === 'position'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
          </th>
          <th>App</th>
          <th style="text-align: center">Rating</th>
          <th>Review</th>
          <th>Replies</th>
          <th style="text-align: center">Jira ID</th>
          <th style="text-align: center">Resolved?</th>
          <th style="text-align: center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in reviews" :key="index">
          <td>{{ formatDate(item.reviewCreatedAt) }}</td>
          <td style="width: 25%">{{ selectedAppForConfig.packageName }}</td>
          <td>{{ item.starRating }} stars</td>
          <td>{{ item.consumerReview }}</td>
          <td class="td text-center">
            <span class="material-icons eye cursor-pointer" @click="viewDescription(item)" v-if="item.developerReply && item.developerReply.reply">
              remove_red_eye
            </span>
            <span v-else style="color: #ccc">No reply</span>
          </td>
          <td v-if="item.jiraId">
            <div style="display: flex; align-items: center; justify-content: center; gap: 1rem">
              <div style="display: flex; align-items: center; justify-content: center; padding-top: 1rem">
                <p>ANVL-</p>
                <p>{{ item.jiraId }}</p>
              </div>
              <vs-button @click="openTicketModal(item)" icon="edit" style="border-radius: 50%" v-if="!item.resolved"></vs-button>
            </div>
          </td>
          <td style="text-align: center" v-else>
            <vs-button @click="openTicketModal(item)">Add Jira ID</vs-button>
          </td>
          <td style="text-align: center">
            <input type="checkbox" v-model="item.resolved" style="height: 30px; width: 20px" @change="markResolved(item)" />
          </td>
          <td>
            <div style="align-items: center; justify-content: center; display: flex">
              <vs-button
                color="danger"
                icon="delete"
                @click="
                  deletePopup = true;
                  deleteSelect = item;
                "
                style="border-radius: 50%"
              ></vs-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else style="text-align: center; font-size: 1rem; margin-top: 20px">No data for selected filters</p>

    <!-- pagination -->
    <vs-pagination class="mt-4" v-model="currentPage" :total="totalPages" :limit="limit" @change="fetchReviews" v-if="reviews.length > 0" />

    <vs-popup small :title="selectedReview && selectedReview.jiraId ? 'Edit Jira ID' : 'Add Jira ID'" :active.sync="isModalOpen">
      <div style="display: flex; align-items: center">
        <p>ANVL-</p>
        <vs-input v-model="jiraId" placeholder="Enter ID" style="width: 30%" @keypress="allowOnlyNumbers" maxLength="4" />
      </div>
      <vs-button @click="createJiraTicket" class="mt-2">Submit</vs-button>
      <vs-button @click="jiraId = ''" class="mt-2 ml-2">Clear</vs-button>
    </vs-popup>

    <vs-popup small :title="'Delete Review'" :active.sync="deletePopup">
      <p>Are you sure you want to delete this review?</p>
      <vs-button @click="deleteReview" class="mt-2" style="width: 4rem">Yes</vs-button>
      <vs-button @click="deletePopup = false" class="mt-2 ml-2" style="width: 4rem">No</vs-button>
    </vs-popup>

    <vs-popup title="View Dev Reply" :active.sync="viewDetails">
      <div>{{ details }}</div>
    </vs-popup>
  </div>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import moment from "moment";

export default {
  name: "ReviewList",
  props: {
    selectedAppForConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reviews: [],
      issueTypes: ["Bug", "Task"],
      isModalOpen: false,
      selectedReview: null,
      jiraId: "",
      jiraDescription: "",
      jiraType: "",
      deletePopup: false,
      deleteSelect: null,
      filters: {
        showStars: "all",
        showResolved: "all",
      },
      limit: 15,
      currentPage: 1,
      totalPages: 0,
      sortByField: "asc",
      sortDirection: "",
      viewDetails: false,
      details: "",
    };
  },
  watch: {
    selectedAppForConfig: {
      handler() {
        this.fetchReviews();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    sortedData() {
      if (this.sortByField) {
        return this.$data.reviews.sort((a, b) => {
          if (this.sortDirection === "asc") {
            return a[this.sortByField] > b[this.sortByField] ? 1 : -1;
          } else {
            return a[this.sortByField] < b[this.sortByField] ? 1 : -1;
          }
        });
      }
      return this.all;
    },
    allowOnlyNumbers() {
      return (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          e.preventDefault();
        }
      };
    },
  },
  methods: {
    sortBy(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortByField = field;
        this.sortDirection = "asc";
      }
      this.$data.reviews = this.sortedData;
    },

    formatDate(date) {
      const timestamp = date.seconds;
      const nanoseconds = date.nanoseconds;

      const Date = moment.unix(timestamp).add(nanoseconds / 1000000, "milliseconds");
      return Date.format("DD-MM-YYYY");
    },

    viewDescription(i) {
      this.$data.viewDetails = true;
      this.$data.details = i.developerReply.reply;
    },

    openTicketModal(review) {
      this.selectedReview = review;
      if (this.selectedReview.jiraId) this.jiraId = this.selectedReview.jiraId;
      this.isModalOpen = true;
    },

    async fetchReviews() {
      const page = !isNaN(this.currentPage) && this.currentPage > 0 ? this.currentPage : 1;

      this.$vs.loading();
      try {
        const res = await api.get(
          `${API.GET_REVIEWSTR_BY_ID}/${this.selectedAppForConfig._id}?rating=${this.filters.showStars}&resolved=${this.filters.showResolved}&page=${page}&limit=${this.limit}`
        );

        if (res.status == 200) {
          res.data.data.sort((a, b) => {
            return a.reviewCreatedAt.seconds - b.reviewCreatedAt.seconds;
          });
          this.$data.reviews = res.data.data;
          this.totalPages = Math.ceil(res.data.total / this.limit);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async createJiraTicket() {
      if (!this.jiraId) return this.$vs.notify({ title: "Error", text: "Please fill in the JIRA ID", color: "danger" });

      try {
        const res = await api.post(`${API.CREATE_JIRA_TICKET}`, {
          jiraId: this.jiraId,
          reviewId: this.selectedReview._id,
        });

        if (res.status === 200) {
          if (res.data) {
            const data = res.data;
            if (data) {
              this.reviews.find((review) => review._id === this.selectedReview._id).jiraId = data.jiraId;
              this.isModalOpen = false;
              // check if jiraId already existed in the review
              if (this.selectedReview.jiraId) this.$vs.notify({ title: "Success", text: "Jira Ticket Updated!", color: "success" });
              else this.$vs.notify({ title: "Success", text: "Jira Ticket Created!", color: "success" });
              this.jiraId = "";
            }
          }
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({ title: "Error", text: "Failed to create Jira Ticket", color: "danger" });
      } finally {
        this.$vs.loading.close();
      }
    },

    async markResolved(review) {
      this.$vs.loading();

      try {
        const res = await api.put(`${API.MARK_REVIEW_RESOLVED}/${review._id}`);

        if (res.status === 200) {
          if (review.resolved) {
            this.$vs.notify({ title: "Success", text: "Review marked as resolved", color: "success" });
          } else this.$vs.notify({ title: "Success", text: "Review marked as unresolved", color: "success" });
        }
      } catch (error) {
        console.error(error);
        review.resolved = !review.resolved;
        this.$vs.notify({ title: "Error", text: "Failed to mark review as resolved", color: "danger" });
      } finally {
        this.$vs.loading.close();
      }
    },

    async deleteReview() {
      this.$vs.loading();
      try {
        const res = await api.delete(`${API.DELETE_REVIEW}/${this.deleteSelect._id}`);

        if (res.status === 200) {
          this.$vs.notify({ title: "Success", text: "Review deleted", color: "success" });
          this.reviews = this.reviews.filter((review) => review._id !== this.deleteSelect._id);
          this.deleteSelect = null;
          this.deletePopup = false;
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({ title: "Error", text: "Failed to delete review", color: "danger" });
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  async created() {
    await this.fetchReviews();
  },
};
</script>

<style scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}

.review-table {
  width: 100%;
  margin-top: 0.5rem;
  border-collapse: collapse;
}

.review-table th,
.review-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.review-table th {
  background-color: #f2f2f2;
  text-align: left;
}
</style>
